
export type EnrollCourse201OneOfResult = typeof EnrollCourse201OneOfResult[keyof typeof EnrollCourse201OneOfResult];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnrollCourse201OneOfResult = {
  success: 'success',
} as const;
